// extracted by mini-css-extract-plugin
module.exports = {"wrapperUploadImage":"index_wrapperUploadImage__2UnOd","info":"index_info__1WqGK"};